"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaginatedGroupReports = void 0;
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const __enums_1 = require("../../../../__types/__enums");
const createReport_1 = require("../../../__common/createReport");
const getElasticsearchQueryFromFilters_1 = require("../../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const getElasticsearchSortForSortParams_1 = require("../../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const reportHelpers_1 = require("../../../__common/reportHelpers");
const getContentGroupMetrics_1 = require("../../common/getContentGroupMetrics");
const getUserGroupMetrics_1 = require("../../common/getUserGroupMetrics");
const groupsByQuery_1 = require("../../groupsByQuery");
function getPaginatedGroupReports(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParmas, ReportProjection = {} } = input;
        const { groupProjection } = ReportProjection;
        const { filters, from = 0, size = 100 } = reportParmas;
        const sortParams = input.SortParams;
        const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.groupFilters);
        if (Object.keys(query.bool).length > 0) {
            const { groups, total } = yield groupsByQuery_1.getGroupsByQuery({
                requestType: __enums_1.ReportRequestTypeEnum.PAGINATED,
                _source: omit_1.default(groupProjection, ['custom']),
                from,
                size,
                body: { query },
                sort: getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams || [])
            });
            const customProjection = groupProjection && groupProjection.custom;
            let contentGroupMetrics = [];
            let userGroupMetrics = [];
            if (customProjection && customProjection.indexOf('groupMetrics') >= 0) {
                // Fetching groupMetrics corresponding to matching results
                const { user: userGroups, content: contentGroups } = groupBy_1.default(groups, 'groupType');
                contentGroupMetrics = yield getContentGroupMetrics_1.getContentGroupMetrics(contentGroups);
                userGroupMetrics = yield getUserGroupMetrics_1.getUserGroupMetrics(userGroups);
            }
            // Fetching and setting related users like reviewer, assigner
            if (ReportProjection.relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, ReportProjection.relatedUserProjection, groups);
            }
            return createReport_1.createGroupReport({ groups, total, userGroupMetrics, contentGroupMetrics });
        }
        return createReport_1.createGroupReport({ groups: [], total: 0, userGroupMetrics: [], contentGroupMetrics: [] });
    });
}
exports.getPaginatedGroupReports = getPaginatedGroupReports;
//# sourceMappingURL=index.js.map